export default [
    {
        title: 'Общее',
        items: [
            {
                q: 'Что такое «Аквариум»?',
                a: 'Аквариум — мессенджер и микроблог в одном приложении. Переписывайся, звони, публикуй записи и читай ленту других пользователей — все в одном месте.',
            },
            {
                q: 'Для кого создан Аквариум?',
                a: 'Для людей, которым важны мысли, а не охваты. Для тех, кто устал от алгоритмов, шума и бесконечных лент.',
            },
            {
                q: 'Сколько лет Аквариуму?',
                a: 'Проект «Аквариум» был начат 21 июня 2025 года. До этого с 2019 года в разработке находился одноимённый проект — социальная сеть с возможностью ведения профиля и публикации записей.',
            },
            {
                q: 'Команда Аквариума',
                a: '<ul><li>Даниил Дыбка, автор проекта, <a href="mailto:daniil@dybka.ru">daniil@dybka.ru</a></li><li>Александр Семченко, веб-разработчик, <a href="mailto:rephose@mail.ru">rephose@mail.ru</a></li><li>Максим Ефимцев, веб-разработчик</li></ul>',
            },
            {
                q: 'Аквариум бесплатный?',
                a: 'Да, Аквариум полностью бесплатный. Все функции доступны без подписки и скрытых платежей.',
            },
            {
                q: 'На каком языке работает сервис?',
                a: 'Интерфейс Аквариума доступен на русском языке.',
            },
            {
                q: 'Открыт ли исходный код?',
                a: 'Да, исходный код клиентской части открыт — вы можете ознакомиться с ним и убедиться в том, как он работает. Веб-клиент на GitHub: <a href="https://github.com/DanyaBooba/aquarium-web-client" target="_blank">aquarium-web-client</a>. Мобильное приложение на GitHub: <a href="https://github.com/DanyaBooba/aquarium-mobile-app" target="_blank">aquarium-mobile-app</a>.',
            },
        ],
    },
    {
        title: 'Регистрация и вход',
        items: [
            {
                q: 'Как зарегистрироваться в Аквариуме?',
                a: 'Зарегистрироваться можно двумя способами: через электронную почту или через аккаунт Яндекса. При регистрации через почту потребуется подтвердить адрес электронной почты с помощью кода.',
            },
            {
                q: 'Как происходит вход в аккаунт?',
                a: 'Вход всегда начинается с отправки кода подтверждения на вашу электронную почту. Если вы установили пароль, после ввода кода потребуется дополнительно ввести его. Это обеспечивает двойную защиту аккаунта.',
            },
            {
                q: 'Можно ли войти через Яндекс?',
                a: 'Да, поддерживается быстрый вход через аккаунт Яндекса — без необходимости вводить email и ждать кода.',
            },
            {
                q: 'Зачем нужен пароль, если вход и так работает через код?',
                a: 'Пароль — это дополнительный уровень защиты. Без пароля кто угодно, кто получит доступ к вашей почте, сможет войти в аккаунт. С паролем для входа потребуются оба фактора: код на почту и пароль.',
            },
            {
                q: 'Есть ли ограничение по возрасту для регистрации?',
                a: 'Да. Сервис предназначен для пользователей старше 14 лет. Лицам от 14 до 18 лет для использования сервиса необходимо согласие родителей или законных представителей.',
            },
        ],
    },
    {
        title: 'Сообщения и чаты',
        items: [
            {
                q: 'Какие чаты есть в Аквариуме?',
                a: 'Доступны личные чаты один на один и групповые чаты. Создать групповой чат может любой пользователь, ограничения на число участников нет. В групповых чатах предусмотрены роли участников.',
            },
            {
                q: 'Можно ли отправлять файлы в чатах?',
                a: 'Да. В чатах можно отправлять файлы любых типов, а также фото и видео — до 5 вложений в одном сообщении.',
            },
            {
                q: 'Видно ли, что сообщение прочитано?',
                a: 'Да, у сообщений отображается статус прочтения.',
            },
            {
                q: 'Что можно делать с сообщением?',
                a: 'Сообщение можно переслать, ответить на него, поставить реакцию из набора доступных эмодзи, отредактировать или удалить.',
            },
            {
                q: 'Как работают редактирование и удаление сообщений?',
                a: 'Отредактировать сообщение можно в течение 2 недель после отправки — изменение увидят все участники чата. Удалить сообщение можно как только у себя, так и сразу у всех собеседников.',
            },
            {
                q: 'Сколько хранится история сообщений?',
                a: 'История сообщений хранится бессрочно — до тех пор, пока аккаунт активен. При удалении аккаунта вы можете выбрать, сохранить ли историю сообщений для собеседников или удалить её полностью.',
            },
            {
                q: 'Что произойдёт с чатом, если собеседник удалит аккаунт?',
                a: 'При удалении аккаунта пользователь может выбрать: сохранить историю переписки для собеседников или удалить все свои сообщения. Если он выбрал удаление — сообщения исчезнут и у вас. Это работает одинаково для личных и групповых чатов.',
            },
        ],
    },
    {
        title: 'Звонки',
        items: [
            {
                q: 'Какие звонки поддерживает Аквариум?',
                a: 'В Аквариуме доступны видеозвонки один на один, а также звонки только с аудио — без включения камеры.',
            },
            {
                q: 'Можно ли позвонить только голосом, без видео?',
                a: 'Да, можно совершить голосовой звонок без включения видео.',
            },
        ],
    },
    {
        title: 'Профили',
        items: [
            {
                q: 'Что можно указать в профиле?',
                a: 'Профиль содержит: имя, фамилию, имя пользователя (никнейм), описание, аватарку и шапку профиля.',
            },
            {
                q: 'Что отображается в профиле и кому он виден?',
                a: 'В профиле отображаются имя, фамилия, никнейм, аватарка, шапка профиля, записи и комментарии пользователя. Профиль и записи видны всем, в том числе незарегистрированным пользователям.',
            },
            {
                q: 'Можно ли сменить никнейм?',
                a: 'Да, никнейм можно изменить в настройках профиля.',
            },
            {
                q: 'Можно ли изменить имя и фамилию?',
                a: 'Да, имя и фамилию можно изменить в любое время в настройках профиля.',
            },
            {
                q: 'Кто видит мои подписки?',
                a: 'Информация о ваших подписках видна всем пользователям.',
            },
        ],
    },
    {
        title: 'Публикации',
        items: [
            {
                q: 'Какие записи можно публиковать?',
                a: 'Короткие текстовые записи длиной до 800 символов с возможностью прикрепить до 5 медиа (фото и видео).',
            },
            {
                q: 'Можно ли форматировать запись?',
                a: 'Да, для записей доступно форматирование: жирный текст, курсив, заголовок и список. При вставке ссылки она автоматически станет кликабельной.',
            },
            {
                q: 'Можно ли прикрепить фотографию или видео?',
                a: 'Да, к одной записи можно прикрепить до 5 медиа (фото и видео).',
            },
            {
                q: 'Можно ли редактировать запись после публикации?',
                a: 'Да, опубликованную запись можно редактировать в любое время.',
            },
            {
                q: 'Можно ли удалить запись?',
                a: 'Да, запись можно удалить в любой момент.',
            },
            {
                q: 'Как можно взаимодействовать с записью?',
                a: 'Запись можно лайкнуть, добавить в избранное, чтобы вернуться к ней позже, и оставить комментарий.',
            },
            {
                q: 'Проходят ли записи модерацию?',
                a: 'Да, каждая запись проходит этап модерации перед публикацией.',
            },
        ],
    },
    {
        title: 'Комментарии',
        items: [
            {
                q: 'Как устроены комментарии?',
                a: 'Записи можно комментировать. В комментариях доступно то же форматирование, что и в записях (жирный текст, курсив, заголовок, список), можно прикрепить до 5 медиа (фото и видео) и ставить лайки.',
            },
            {
                q: 'Можно ли редактировать или удалить комментарий?',
                a: 'Да, свой комментарий можно отредактировать или удалить в любой момент.',
            },
            {
                q: 'Проходят ли комментарии модерацию?',
                a: 'Да, как и записи, комментарии проходят этап модерации перед публикацией.',
            },
        ],
    },
    {
        title: 'Лента и навигация',
        items: [
            {
                q: 'Какие ленты есть в Аквариуме?',
                a: 'Доступны две ленты: общая лента с последними записями и лента подписок с записями пользователей, на которых вы подписаны.',
            },
            {
                q: 'Как формируется общая лента?',
                a: 'Общая лента формируется хронологически и показывает последние записи всех пользователей.',
            },
            {
                q: 'Как формируется лента подписок?',
                a: 'Лента подписок показывает записи пользователей, на которых вы подписаны, в хронологическом порядке.',
            },
            {
                q: 'Используются ли алгоритмы или рекомендации?',
                a: 'Нет. Все ленты формируются строго в хронологическом порядке, без алгоритмов и скрытого ранжирования.',
            },
            {
                q: 'Можно ли подписываться на пользователей?',
                a: 'Да. Подписка позволяет видеть записи пользователя в ленте подписок.',
            },
            {
                q: 'Есть ли поиск?',
                a: 'Да. Доступен поиск по пользователям и записям.',
            },
        ],
    },
    {
        title: 'Уведомления',
        items: [
            {
                q: 'Какие уведомления есть в Аквариуме?',
                a: 'Аквариум поддерживает push-уведомления и уведомления на электронную почту. Уведомления приходят о новых сообщениях, новых комментариях к вашим записям и о публикации вашей записи после модерации.',
            },
            {
                q: 'Приходят ли уведомления на почту?',
                a: 'Да, уведомления могут дублироваться на адрес электронной почты, указанный при регистрации.',
            },
        ],
    },
    {
        title: 'Настройки',
        items: [
            {
                q: 'Есть ли тёмная тема?',
                a: 'Да, в Аквариуме доступна тёмная тема. Переключить её можно в настройках.',
            },
            {
                q: 'Что можно настроить в оформлении?',
                a: 'Помимо тёмной темы, можно настроить вид профиля и вид записей. В мобильном приложении также доступна смена цвета иконки приложения.',
            },
            {
                q: 'Можно ли настроить приватность?',
                a: 'Да, в настройках доступны расширенные настройки приватности — вы можете гибко управлять доступом к своим данным и профилю.',
            },
            {
                q: 'Можно ли управлять активными сессиями?',
                a: 'Да, в настройках можно просматривать все активные сессии и завершать их. Завершение сессии доступно через 48 часов после последнего входа.',
            },
            {
                q: 'Что делать, если потерял устройство?',
                a: 'Войдите в аккаунт с другого устройства, проверьте список активных сессий и завершите подозрительные. Если у вас ещё не установлен пароль — рекомендуем его установить.',
            },
        ],
    },
    {
        title: 'Конфиденциальность и безопасность',
        items: [
            {
                q: 'Как защищены мои данные?',
                a: 'Используются HTTPS, шифрование сообщений, CSRF-защита, подписанные сервером токены и защита от SQL-инъекций.',
            },
            {
                q: 'Шифруются ли данные при передаче?',
                a: 'Да, все данные передаются по защищённому протоколу HTTPS.',
            },
            {
                q: 'Как хранятся пароли?',
                a: 'Пароли хранятся в зашифрованном виде с использованием алгоритма Bcrypt. Мы не имеем доступа к вашему паролю в открытом виде.',
            },
            {
                q: 'Может ли команда читать мои сообщения?',
                a: 'Нет, все сообщения хранятся в зашифрованном виде и недоступны для просмотра командой сервиса.',
            },
            {
                q: 'Планируется ли end-to-end шифрование?',
                a: 'Да, в будущем планируется приватный режим общения с end-to-end шифрованием, при котором сообщения будут доступны только участникам переписки.',
            },
            {
                q: 'Логируются ли сообщения и личные данные?',
                a: 'Логирование ведётся, но не содержит личных данных пользователей и содержимого сообщений.',
            },
            {
                q: 'Используются ли сторонние сервисы для хранения данных?',
                a: 'Нет. Все данные хранятся исключительно на собственных серверах Аквариума, расположенных в России.',
            },
            {
                q: 'Какие данные собираются при регистрации?',
                a: 'При регистрации собираются электронная почта и имя.',
            },
            {
                q: 'Какие данные собираются автоматически?',
                a: 'Автоматически собираются: user-agent, fingerprint устройства и IP-адрес.',
            },
            {
                q: 'Используются ли аналитические сервисы?',
                a: 'Да, используется Яндекс Метрика для сбора обезличенной статистики. Рекламные SDK и трекеры не используются.',
            },
            {
                q: 'Передаются ли мои данные третьим лицам?',
                a: 'Нет. Данные не продаются и не передаются третьим лицам в коммерческих целях.',
            },
            {
                q: 'Как защищён вход в аккаунт?',
                a: 'Вход защищён кодом подтверждения на почту, CSRF-защитой и подписанными токенами. Дополнительно можно установить пароль.',
            },
            {
                q: 'Можно ли удалить аккаунт и все данные?',
                a: 'Да. Удаление аккаунта полное и немедленное — период ожидания отсутствует. Все данные удаляются. Удалить аккаунт можно в настройках профиля.',
            },
            {
                q: 'Сколько хранятся мои данные?',
                a: 'Данные аккаунта хранятся бессрочно, пока аккаунт активен. Метаданные переписки хранятся 1 год, содержимое сообщений — 6 месяцев в соответствии с требованиями законодательства РФ. После удаления аккаунта данные, не подпадающие под требования закона, удаляются немедленно.',
            },
            {
                q: 'Есть ли модерация контента?',
                a: 'Да, каждая запись и каждый комментарий проходят этап модерации перед публикацией.',
            },
            {
                q: 'Можно ли обжаловать блокировку аккаунта?',
                a: 'Да. Если вы считаете, что блокировка была применена ошибочно, напишите нам через форму поддержки или на <a href="mailto:daniil@dybka.ru">daniil@dybka.ru</a>.',
            },
            {
                q: 'Будет ли регулярно улучшаться безопасность?',
                a: 'Да, безопасность является приоритетом проекта. Аквариум регулярно обновляется и улучшается с точки зрения защиты данных.',
            },
        ],
    },
    {
        title: 'Поддержка',
        items: [
            {
                q: 'Как обратиться в поддержку?',
                a: 'Обратиться в поддержку можно через форму обратной связи в приложении или по адресу <a href="mailto:daniil@dybka.ru">daniil@dybka.ru</a>.',
            },
            {
                q: 'Как долго рассматриваются обращения?',
                a: 'Мы стараемся отвечать на все обращения в течение 7 рабочих дней.',
            },
            {
                q: 'Что делать, если мой аккаунт заблокирован?',
                a: 'Напишите в поддержку через форму или на <a href="mailto:daniil@dybka.ru">daniil@dybka.ru</a> с описанием ситуации. Каждый случай рассматривается индивидуально.',
            },
        ],
    },
    {
        title: 'Мобильное приложение',
        items: [
            {
                q: 'Есть ли мобильное приложение?',
                a: 'Да, мобильное приложение Аквариума доступно для Android и iOS.',
            },
            {
                q: 'Где скачать приложение?',
                a: 'Приложение доступно в <a href="https://play.google.com/store/apps/details?id=aquarium.app" target="_blank">Google Play</a> и <a href="https://apps.apple.com/us/app/%D0%B0%D0%BA%D0%B2%D0%B0%D1%80%D0%B8%D1%83%D0%BC-%D0%BC%D0%B5%D1%81%D1%81%D0%B5%D0%BD%D0%B4%D0%B6%D0%B5%D1%80-%D0%B8-%D0%B1%D0%BB%D0%BE%D0%B3/id6771532179" target="_blank">App Store</a>. Все ссылки собраны на странице <a href="https://aquarium.org.ru/apps" target="_blank">aquarium.org.ru/apps</a>.',
            },
        ],
    },
    {
        title: 'Будущее проекта',
        items: [
            {
                q: 'Какие функции планируется добавить?',
                a: 'В ближайших планах: групповые звонки, голосовые сообщения, видеосообщения, прямые трансляции, end-to-end шифрование и OAuth-авторизация через Аквариум.',
            },
            {
                q: 'Как будет развиваться лента?',
                a: 'Планируется добавить алгоритм рекомендаций.',
            },
            {
                q: 'Будет ли интеграция с другими сервисами?',
                a: 'Планируется реализация OAuth — возможность быстрого входа в сторонние сервисы с помощью аккаунта Аквариума.',
            },
            {
                q: 'Какие цели проекта на ближайший год?',
                a: 'Развивать Аквариум как полноценный мессенджер и микроблог: групповые звонки, голосовые и видеосообщения, прямые трансляции.',
            },
            {
                q: 'Какие цели на пять лет?',
                a: 'Сформировать команду проекта и стабильно развивать платформу.',
            },
            {
                q: 'Как пользователи могут участвовать в развитии?',
                a: 'Через открытые предложения и обратную связь — мы внимательно читаем все отзывы.',
            },
            {
                q: 'Какая главная цель проекта?',
                a: 'Обеспечить безопасное, прозрачное и свободное общение для всех пользователей.',
            },
        ],
    },
];
